"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDonutChartOption = exports.buildAreaChartOption = exports.buildGroupedBarOption = exports.buildDistributedHorizontalBarOption = exports.buildStackedHorizontalBarOption = exports.buildLineChartOption = exports.createValueAxis = exports.createCategoryAxis = exports.baseGrid = void 0;
const constants_1 = require("./constants");
const axisLineColor = 'rgba(122, 138, 157, 0.4)';
const defaultLineWidth = 3;
const defaultLinePointSize = 8;
const defaultBarThickness = 32;
const defaultBarBorderRadius = 4;
const barLabelTextColor = '#ffffff';
const defaultAreaSeriesOpacity = 0.3;
const defaultGridLineOpacity = 0.2;
const axisLabelBase = {
    color: 'rgba(38, 50, 56, 0.72)',
    fontFamily: constants_1.fontFamily,
    fontSize: 11
};
const clampToUnit = (value, fallback) => {
    if (typeof value !== 'number' || Number.isNaN(value)) {
        return fallback;
    }
    return Math.min(1, Math.max(0, value));
};
const getDatumValue = (value) => {
    if (typeof value === 'number') {
        return value;
    }
    if (Array.isArray(value)) {
        const first = value[0];
        return typeof first === 'number' ? first : 0;
    }
    if (value && typeof value === 'object' && typeof value.value === 'number') {
        return value.value;
    }
    return 0;
};
const formatBarLabelValue = (rawValue) => {
    const value = getDatumValue(rawValue);
    return value ? `${value}` : '';
};
const getStackedBarLabelSource = (params) => {
    if ((params === null || params === void 0 ? void 0 : params.data) &&
        typeof params.data === 'object' &&
        !Array.isArray(params.data) &&
        Object.prototype.hasOwnProperty.call(params.data, 'labelValue')) {
        return params.data.labelValue;
    }
    return params === null || params === void 0 ? void 0 : params.value;
};
exports.baseGrid = {
    bottom: 40,
    containLabel: true,
    left: 70,
    right: 30,
    top: 30
};
const createCategoryAxis = (categories, overrides) => {
    const _a = overrides !== null && overrides !== void 0 ? overrides : {}, { axisLabel } = _a, rest = __rest(_a, ["axisLabel"]);
    return Object.assign({ axisLabel: Object.assign(Object.assign({}, axisLabelBase), (axisLabel !== null && axisLabel !== void 0 ? axisLabel : {})), axisLine: { lineStyle: { color: axisLineColor } }, axisTick: { alignWithLabel: true }, boundaryGap: false, data: categories, type: 'category' }, rest);
};
exports.createCategoryAxis = createCategoryAxis;
const createValueAxis = (overrides, gridOpacity) => {
    const _a = overrides !== null && overrides !== void 0 ? overrides : {}, { axisLabel } = _a, rest = __rest(_a, ["axisLabel"]);
    const resolvedGridOpacity = clampToUnit(gridOpacity, defaultGridLineOpacity);
    return Object.assign({ axisLabel: Object.assign(Object.assign({}, axisLabelBase), (axisLabel !== null && axisLabel !== void 0 ? axisLabel : {})), axisLine: { lineStyle: { color: axisLineColor } }, splitLine: { lineStyle: { color: `rgba(122, 138, 157, ${resolvedGridOpacity})`, type: 'dashed' } }, type: 'value' }, rest);
};
exports.createValueAxis = createValueAxis;
const defaultLineLabel = {
    color: axisLabelBase.color,
    fontFamily: constants_1.fontFamily,
    fontSize: 12,
    formatter: (params) => formatBarLabelValue(params.value),
    position: 'top',
    show: true
};
const resolveSmoothAndStep = (smooth, curve) => {
    if (curve === 'step') {
        return { smooth: false, step: 'middle' };
    }
    if (typeof smooth === 'number') {
        return { smooth, step: undefined };
    }
    if (typeof smooth === 'boolean') {
        return { smooth, step: undefined };
    }
    if (curve === 'linear') {
        return { smooth: false, step: undefined };
    }
    if (curve === 'monotoneX' || curve === 'natural') {
        return { smooth: true, step: undefined };
    }
    return { smooth: true, step: undefined };
};
const buildLineChartOption = (config) => {
    var _a, _b, _c, _d;
    const xAxis = (0, exports.createCategoryAxis)(config.categories, {
        axisLabel: { show: !config.hideXAxisLabels }
    });
    const { smooth, step } = resolveSmoothAndStep(config.smooth, config.curve);
    const showSymbol = (_a = config.showSymbol) !== null && _a !== void 0 ? _a : false;
    const symbolSize = typeof config.symbolSize === 'number' ? config.symbolSize : defaultLinePointSize;
    const showDataLabels = Boolean(config.showDataLabels);
    return {
        animation: config.animation !== false,
        animationDuration: 400,
        color: config.colors,
        grid: Object.assign(Object.assign({}, exports.baseGrid), ((_b = config.grid) !== null && _b !== void 0 ? _b : {})),
        legend: { show: false },
        series: config.series.map((series) => {
            var _a, _b, _c, _d;
            return (Object.assign(Object.assign({}, series), { label: showDataLabels ? Object.assign(Object.assign({}, defaultLineLabel), ((_a = series.label) !== null && _a !== void 0 ? _a : {})) : { show: false }, lineStyle: Object.assign({ width: (_b = config.strokeWidth) !== null && _b !== void 0 ? _b : defaultLineWidth }, ((_c = series.lineStyle) !== null && _c !== void 0 ? _c : {})), showSymbol,
                smooth, stack: config.stacked ? ((_d = series.stack) !== null && _d !== void 0 ? _d : 'total') : series.stack, step,
                symbolSize, type: 'line' }));
        }),
        tooltip: config.tooltip,
        xAxis,
        yAxis: (0, exports.createValueAxis)(Object.assign(Object.assign({}, config.yAxis), { name: (_c = config.yAxisName) !== null && _c !== void 0 ? _c : (_d = config.yAxis) === null || _d === void 0 ? void 0 : _d.name }), config.gridOpacity)
    };
};
exports.buildLineChartOption = buildLineChartOption;
const buildStackedHorizontalBarOption = (config) => {
    var _a, _b;
    const terminalSeriesByCategory = config.categories.map((_, dataIndex) => {
        for (let seriesIndex = config.series.length - 1; seriesIndex >= 0; seriesIndex -= 1) {
            const dataPoints = Array.isArray(config.series[seriesIndex].data) ? config.series[seriesIndex].data : [];
            const value = getDatumValue(dataPoints[dataIndex]);
            if (value > 0) {
                return seriesIndex;
            }
        }
        return -1;
    });
    const terminalRadius = [0, defaultBarBorderRadius, defaultBarBorderRadius, 0];
    return {
        animationDuration: 400,
        color: config.colors,
        grid: Object.assign(Object.assign({}, exports.baseGrid), ((_a = config.grid) !== null && _a !== void 0 ? _a : {})),
        legend: { show: false },
        series: config.series.map((series, seriesIndex) => {
            var _a, _b, _c;
            const data = Array.isArray(series.data)
                ? series.data.map((datum, dataIndex) => {
                    var _a;
                    if (terminalSeriesByCategory[dataIndex] !== seriesIndex) {
                        return datum;
                    }
                    if (datum && typeof datum === 'object' && !Array.isArray(datum)) {
                        return Object.assign(Object.assign({}, datum), { itemStyle: Object.assign(Object.assign({}, ((_a = datum.itemStyle) !== null && _a !== void 0 ? _a : {})), { borderRadius: terminalRadius }) });
                    }
                    return {
                        itemStyle: { borderRadius: terminalRadius },
                        value: datum
                    };
                })
                : series.data;
            return Object.assign(Object.assign({}, series), { barWidth: defaultBarThickness, data, emphasis: Object.assign({ focus: 'series' }, ((_a = series.emphasis) !== null && _a !== void 0 ? _a : {})), itemStyle: Object.assign({}, ((_b = series.itemStyle) !== null && _b !== void 0 ? _b : {})), label: Object.assign({ align: 'center', color: barLabelTextColor, fontFamily: constants_1.fontFamily, fontSize: 12, formatter: (params) => formatBarLabelValue(getStackedBarLabelSource(params)), position: 'inside', show: true, verticalAlign: 'middle' }, ((_c = series.label) !== null && _c !== void 0 ? _c : {})), stack: 'total', type: 'bar' });
        }),
        tooltip: config.tooltip,
        xAxis: (0, exports.createValueAxis)(),
        yAxis: {
            axisLabel: Object.assign(Object.assign({}, axisLabelBase), ((_b = config.axisLabel) !== null && _b !== void 0 ? _b : {})),
            axisLine: { lineStyle: { color: axisLineColor } },
            axisTick: { alignWithLabel: true },
            boundaryGap: true,
            data: config.categories,
            inverse: true,
            type: 'category'
        }
    };
};
exports.buildStackedHorizontalBarOption = buildStackedHorizontalBarOption;
const buildDistributedHorizontalBarOption = (config) => {
    var _a;
    const seriesData = config.data.map((datum, index) => (Object.assign(Object.assign({}, datum), { itemStyle: {
            borderRadius: [0, defaultBarBorderRadius, defaultBarBorderRadius, 0],
            color: config.colors[index % config.colors.length]
        } })));
    return {
        animationDuration: 400,
        color: config.colors,
        grid: Object.assign(Object.assign({}, exports.baseGrid), ((_a = config.grid) !== null && _a !== void 0 ? _a : {})),
        legend: { show: false },
        series: [
            {
                barWidth: defaultBarThickness,
                data: seriesData,
                label: {
                    align: 'center',
                    color: barLabelTextColor,
                    fontFamily: constants_1.fontFamily,
                    fontSize: 12,
                    formatter: (params) => {
                        const value = getDatumValue(params.value);
                        if (!value) {
                            return '';
                        }
                        return config.labelFormatter ? config.labelFormatter(value, params.dataIndex) : `${value}`;
                    },
                    position: 'inside',
                    show: true,
                    verticalAlign: 'middle'
                },
                type: 'bar'
            }
        ],
        tooltip: config.tooltip,
        xAxis: (0, exports.createValueAxis)(),
        yAxis: {
            axisLabel: Object.assign({}, axisLabelBase),
            axisLine: { lineStyle: { color: axisLineColor } },
            axisTick: { alignWithLabel: true },
            boundaryGap: true,
            data: config.categories,
            inverse: true,
            type: 'category'
        }
    };
};
exports.buildDistributedHorizontalBarOption = buildDistributedHorizontalBarOption;
const buildGroupedBarOption = (config) => {
    var _a;
    const isHorizontal = config.layout === 'horizontal';
    return {
        animationDuration: 400,
        color: config.colors,
        grid: Object.assign(Object.assign({}, exports.baseGrid), ((_a = config.grid) !== null && _a !== void 0 ? _a : {})),
        legend: { show: false },
        series: config.series.map((series) => (Object.assign(Object.assign({}, series), { emphasis: { focus: 'series' }, label: config.showLabels
                ? {
                    color: barLabelTextColor,
                    fontFamily: constants_1.fontFamily,
                    fontSize: 12,
                    formatter: (params) => formatBarLabelValue(params.value),
                    position: 'inside',
                    show: true
                }
                : { show: false }, type: 'bar' }))),
        tooltip: config.tooltip,
        xAxis: isHorizontal
            ? (0, exports.createValueAxis)(undefined, config.valueAxisGridOpacity)
            : {
                axisLabel: Object.assign({}, axisLabelBase),
                axisLine: { lineStyle: { color: axisLineColor } },
                axisTick: { alignWithLabel: true },
                boundaryGap: true,
                data: config.categories,
                type: 'category'
            },
        yAxis: isHorizontal
            ? {
                axisLabel: Object.assign({}, axisLabelBase),
                axisLine: { lineStyle: { color: axisLineColor } },
                axisTick: { alignWithLabel: true },
                boundaryGap: true,
                data: config.categories,
                inverse: true,
                type: 'category'
            }
            : (0, exports.createValueAxis)(undefined, config.valueAxisGridOpacity)
    };
};
exports.buildGroupedBarOption = buildGroupedBarOption;
const buildAreaChartOption = (config) => {
    var _a, _b, _c, _d, _e;
    const xAxis = (0, exports.createCategoryAxis)(config.categories, {
        axisLabel: { show: !config.hideXAxisLabels }
    });
    const { smooth, step } = resolveSmoothAndStep(config.smooth, config.curve);
    const showSymbol = (_a = config.showSymbol) !== null && _a !== void 0 ? _a : false;
    const symbolSize = typeof config.symbolSize === 'number' ? config.symbolSize : defaultLinePointSize;
    const showDataLabels = Boolean(config.showDataLabels);
    const opacity = (_b = config.areaOpacity) !== null && _b !== void 0 ? _b : defaultAreaSeriesOpacity;
    return {
        animation: config.animation !== false,
        animationDuration: 400,
        color: config.colors,
        grid: Object.assign(Object.assign({}, exports.baseGrid), ((_c = config.grid) !== null && _c !== void 0 ? _c : {})),
        legend: { show: false },
        series: config.series.map((series) => {
            var _a, _b, _c, _d, _e;
            return (Object.assign({ areaStyle: Object.assign({ opacity }, ((_a = series.areaStyle) !== null && _a !== void 0 ? _a : {})), label: showDataLabels ? Object.assign(Object.assign({}, defaultLineLabel), ((_b = series.label) !== null && _b !== void 0 ? _b : {})) : { show: false }, lineStyle: Object.assign({ width: (_c = config.strokeWidth) !== null && _c !== void 0 ? _c : defaultLineWidth }, ((_d = series.lineStyle) !== null && _d !== void 0 ? _d : {})), showSymbol,
                smooth, stack: config.stacked ? ((_e = series.stack) !== null && _e !== void 0 ? _e : 'total') : series.stack, step,
                symbolSize, type: 'line' }, series));
        }),
        tooltip: config.tooltip,
        xAxis,
        yAxis: (0, exports.createValueAxis)(Object.assign(Object.assign({}, config.yAxis), { name: (_d = config.yAxisName) !== null && _d !== void 0 ? _d : (_e = config.yAxis) === null || _e === void 0 ? void 0 : _e.name }), config.gridOpacity)
    };
};
exports.buildAreaChartOption = buildAreaChartOption;
const buildDonutChartOption = (config) => {
    const legend = Object.assign({ orient: 'vertical', right: 0, textStyle: { fontFamily: constants_1.fontFamily, fontSize: 12 }, top: 'center', type: 'scroll' }, config.legend);
    return {
        animationDuration: 400,
        color: config.colors,
        legend,
        series: [
            {
                avoidLabelOverlap: true,
                center: ['42%', '50%'],
                data: config.data,
                label: {
                    formatter: ({ percent }) => `${percent === null || percent === void 0 ? void 0 : percent.toFixed(2)}%`,
                    show: true
                },
                radius: ['45%', '70%'],
                type: 'pie'
            }
        ],
        tooltip: config.tooltip
    };
};
exports.buildDonutChartOption = buildDonutChartOption;
//# sourceMappingURL=options.js.map